<template>
  <button
    type="button"
    class="btn-prev"
    :disabled="internalDisabled"
    :aria-label="prevText || t('lt.pagination.prev')"
    :aria-disabled="internalDisabled"
    @click="$emit('click', $event)"
  >
    <span v-if="prevText">{{ prevText }}</span>
    <lt-icon v-else>
      <component :is="prevIcon" />
    </lt-icon>
  </button>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { LtIcon } from '@lit-element/components/icon'
import { useLocale } from '@lit-element/hooks'
import { paginationPrevEmits, paginationPrevProps } from './prev'

defineOptions({
  name: 'LtPaginationPrev',
})

const props = defineProps(paginationPrevProps)
defineEmits(paginationPrevEmits)

const { t } = useLocale()

const internalDisabled = computed(
  () => props.disabled || props.currentPage <= 1
)
</script>
